<template>
  <div></div>
</template>
<script>
import { getAttributes } from '@/utils/http/modules/common.request.js'
const fontSizeKey = 'MY_FONTSIZE'
const fontSizeByTpid = 'TPID_FONTSIZE'
const whitePages = [
  '/memberPoints/index',
  '/memberPoints/task',
  '/memberPoints/mall',
  '/memberPoints/order',
  '/memberPoints/bill',
  '/memberPoints/sign',
  '/memberPoints/product/',
  '/memberPoints/success/',
]

export default {
  mounted() {
    if (whitePages.find(url => location.href.includes(url))) {
      this.getTopicFontSize()
    } else {
      this.init()
    }
    this.$bus.$on('CHANGE_FONT_SIZE', () => {
      this.init()
    })
  },
  methods: {
    init({ count = 4, key = fontSizeKey } = {}) {
      let scale = window.localStorage.getItem(key) || 0
      this.$store.commit('UPDATE_FONTSIZE', scale)
      const fonstStyle1 = {
        '--set-font-size9': `calc(9px + ${count * scale}px)`,
        '--set-font-size10': `calc(10px + ${count * scale}px)`,
        '--set-font-size11': `calc(11px + ${count * scale}px)`,
        '--set-font-size12': `calc(12px + ${count * scale}px)`,
        '--set-font-size13': `calc(13px + ${count * scale}px)`,
        '--set-font-size14': `calc(14px + ${count * scale}px)`,
        '--set-font-size15': `calc(15px + ${count * scale}px)`,
        '--set-font-size16': `calc(16px + ${count * scale}px)`,
        '--set-font-size17': `calc(17px + ${count * scale}px)`,
        '--set-font-size18': `calc(18px + ${count * scale}px)`,
        '--set-font-size19': `calc(19px + ${count * scale}px)`,
        '--set-font-size20': `calc(20px + ${count * scale}px)`,
        '--set-font-size22': `calc(22px + ${count * scale}px)`,
        '--set-font-size23': `calc(23px + ${count * scale}px)`,
        '--set-font-size24': `calc(24px + ${count * scale}px)`,
        '--set-font-size25': `calc(25px + ${count * scale}px)`,
        '--set-font-size28': `calc(28px + ${count * scale}px)`,
        '--set-font-size32': `calc(32px + ${count * scale}px)`,
      }

      Object.keys(fonstStyle1).forEach(v => {
        document.documentElement.style.setProperty(v, fonstStyle1[v])
      })
    },
    // 获取话题设置的字体大小
    async getTopicFontSize() {
      if (!window.zbvd.tpid) {
        window.localStorage.setItem(fontSizeByTpid, 0)
        this.init({ key: fontSizeByTpid })
        return
      }
      let scale = 0
      try {
        // 这接口有时候会返回报错，报错则用顶层window的配置
        const res = await getAttributes({
          tpId: window.zbvd.tpid,
          type: '1335',
        })
        console.log('fontsize-request', res)
        if (res.data.attrVal) {
          const attr = JSON.parse(res.data.attrVal)
          scale = attr.font_size == 0 ? 1 : attr.font_size == 2 ? 2 : 0
        }
      } catch (error) {
        const { font_size } =
          (window.top.zbvd && window.top.zbvd.commentAreaSetting) || {}
        console.log('fontsize-catch', error, font_size)
        scale = font_size == 0 ? 1 : font_size == 2 ? 2 : 0
      }
      window.localStorage.setItem(fontSizeByTpid, scale)
      this.init({ key: fontSizeByTpid })
    },
  },
}
</script>
<style lang="scss"></style>
